import React from 'react';
import { Button } from 'react-bootstrap';
import { Form, FormikProps } from 'formik';
import {
    CheckboxField,
    DateField,
    InputField,
    ResponseError,
    SubmitButton,
    TextAreaField,
} from '@nintendo/forms';
import moment from 'moment-timezone';
import { FormType } from '../../../common/types/formTypes';
import { DATE_ONLY_FORMAT, SERVER_TIMEZONE } from '../../../../utils/Constants';
import { AmAdminItemType } from '../../../../api/amAdminApiTypes';

export interface TemplateTypesFormType extends AmAdminItemType {
    id?: number;
    name: string;
}

export interface TemplateTypesFormProps extends FormikProps<TemplateTypesFormType> {
    formType: FormType;
    responseError: string;
    setResponseError: (errorMessage: string) => void;
    toggleModal: () => void;
}

const TemplateTypesForm = (props: TemplateTypesFormProps) => {
    const { values, errors, touched, isSubmitting } = props;

    return (
        <div className="modal-content" data-testid="eventGroup-modal-content">
            <div className="modal-header">
                <h4 className="modal-title">
                    {props.formType === FormType.UPDATE ? 'Edit' : 'Create'} Template Type
                </h4>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" onClick={props.toggleModal}>
                        &times;
                    </span>
                </button>
            </div>
            <Form className="form-horizontal">
                <div className="modal-body">
                    <ResponseError errorMessage={props.responseError} />

                    <CheckboxField
                        label="Status"
                        name="active"
                        touched={touched.active}
                        errors={errors.active}
                        checkboxLabel="Active"
                        testId="active"
                    />
                    {props.formType === FormType.CREATE || props.formType === FormType.CLONE ? (
                        <InputField
                            label="Template Type Name"
                            name="name"
                            touched={touched.name}
                            errors={errors.name}
                            isRequired
                            testId="name"
                        />
                    ) : (
                        <div className="form-group row">
                            <div className="col-sm-5 control-label">Template Type Name</div>
                            <div className="col-sm-7">{values.name}</div>
                        </div>
                    )}
                    <TextAreaField
                        label="Description"
                        name="description"
                        touched={touched.description}
                        errors={errors.description}
                        isRequired
                        testId="description"
                    />
                    <DateField
                        label="Start Date"
                        name="startDate"
                        flatpickrProps={{
                            options: {
                                altInputClass: 'form-control',
                                altFormat: DATE_ONLY_FORMAT,
                                enableTime: false,
                                dateFormat: DATE_ONLY_FORMAT,
                                static: true,
                            },
                            value: values.startDate
                                ? moment(values.startDate).format(DATE_ONLY_FORMAT)
                                : undefined,
                        }}
                        timezone={SERVER_TIMEZONE}
                        touched={touched.startDate}
                        errors={errors.startDate}
                        isRequired
                        testId="startDate"
                    />
                    <DateField
                        label="End Date"
                        name="endDate"
                        flatpickrProps={{
                            options: {
                                altInputClass: 'form-control',
                                altFormat: DATE_ONLY_FORMAT,
                                enableTime: false,
                                dateFormat: DATE_ONLY_FORMAT,
                                static: true,
                            },
                            value: values.endDate
                                ? moment(values.endDate).format(DATE_ONLY_FORMAT)
                                : undefined,
                        }}
                        timezone={SERVER_TIMEZONE}
                        touched={touched.endDate}
                        errors={errors.endDate}
                        testId="endDate"
                    />
                </div>

                {/* Footer */}

                <div className="modal-footer">
                    <Button
                        variant="button"
                        className="btn-outline-secondary mr-auto"
                        onClick={props.toggleModal}
                        disabled={isSubmitting}
                    >
                        Close
                    </Button>
                    <SubmitButton isSubmitting={isSubmitting} buttonText="Save" />
                </div>
            </Form>
        </div>
    );
};

export default TemplateTypesForm;
